import { render, staticRenderFns } from "./CatalogoTiposEmpresas.vue?vue&type=template&id=320b56e6"
import script from "./CatalogoTiposEmpresas.vue?vue&type=script&lang=js"
export * from "./CatalogoTiposEmpresas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports